module.exports = __webpack_public_path__ + "assets/img/logo-maintenance.98f2f594.png";